import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';

const Discounts = React.lazy(() => import('./index'));
const DiscountTable = React.lazy(() => import('./discountTable'));
const Discount = React.lazy(() => import('./discount'));
const DiscountDetail = React.lazy(() => import('./discountDetail'));
const AddNewDiscount = React.lazy(() => import('./addNewDiscount'));
const EditDiscount = React.lazy(() => import('./editDiscount'));

export const useDiscountRoutes = () => {

    return (
        <Route path="discounts" element={<Suspense fallback={<div>منتظر باشید...</div>}><Discounts /></Suspense>} >
            <Route index element={<Suspense fallback={<div>منتظر باشید...</div>}><DiscountTable /></Suspense>} />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewDiscount /></Suspense>} />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Discount /></Suspense>} >
                <Route index element={<Suspense fallback={<div>منتظر باشید...</div>}><DiscountDetail /></Suspense>} />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditDiscount /></Suspense>} />
            </Route>
        </Route>
    )
}